import { render } from "./CheckoutLegalOptions.vue?vue&type=template&id=66a379c8"
import script from "./CheckoutLegalOptions.vue?vue&type=script&lang=js"
export * from "./CheckoutLegalOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__